export default class User {
    constructor(firstname, lastname, username, email, password) {
      this.username = username;
      this.email = email;
      this.password = password;
      this.firstname = firstname;
      this.lastname = lastname;
    }
  }